import { generateClient, isCancelError } from "aws-amplify/api";

const client = generateClient();

export async function requestListNews(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_NEWS", payload: { request: null } });

    const request = client.graphql({
      query: newsBySourcePublishedAt,
      variables: {
        source: "PajakInd",
        limit: 5,
        sortDirection: "DESC",
      },
    });

    dispatch({ type: "REQUEST_LIST_NEWS", payload: { request } });

    const res = await request;
    const { items } = res.data.newsBySourcePublishedAt;

    dispatch({
      type: "LIST_NEWS_SUCCESS",
      payload: { items },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "LIST_NEWS_ERROR", error: null });
    } else {
      dispatch({ type: "LIST_NEWS_ERROR", error });
    }
  }
}

const newsBySourcePublishedAt = /* GraphQL */ `
  query NewsBySourcePublishedAt(
    $source: String
    $publishedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsBySourcePublishedAt(
      source: $source
      publishedAt: $publishedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        author
        imageUrl
        url
        source
        publishedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
